import { useEffect } from 'react'
import { loadStart, loadSuccess, loadError } from '../reducer'
import { apiFetch } from '../api'

// Loads the handicap summary once per URL. Data-fetching effect with a
// cancellation guard so a stale response can't overwrite fresh state (REACT-089).
const useLoadSummary = (url, dispatch, failMessage) => {
  useEffect(() => {
    let cancelled = false
    loadStart(dispatch)
    apiFetch(url)
      .then((data) => { if (!cancelled) loadSuccess(dispatch, data) })
      .catch((e) => { if (!cancelled) loadError(dispatch, (e && e.message) || failMessage) })
    return () => { cancelled = true }
  }, [url])
}

export default useLoadSummary
